/**
 * Extract the operation name from a GraphQL query/mutation string.
 * Returns "unknown" if no named operation is found or if document is null/undefined.
 */
export function extractOperationName(document: string): string {
  if (!document) return "unknown";
  const match = document.match(/(?:query|mutation|subscription)\s+(\w+)/);
  return match?.[1] ?? "unknown";
}

/**
 * Whether a GraphQL ClientError is the EXPECTED 4-hour inactivity logout
 * (core-service 401 with code SESSION_TIMEOUT). AuthContext's session
 * handler already catches it and routes to sign-in, but the query/mutation
 * hooks were still reporting each one to Sentry — 588 prod events of pure
 * noise from overnight tabs (TASKENG-FRONTEND-4). Real 401s (missing/bad
 * token) don't carry SESSION_TIMEOUT and still report.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isExpectedSessionTimeout(error: any): boolean {
  return (
    error?.response?.status === 401 &&
    String(error?.message ?? "").includes("SESSION_TIMEOUT")
  );
}
